var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-nav-bar',{attrs:{"title":_vm.title,"left-arrow":_vm.$route.meta.headReturn,"fixed":""},on:{"click-left":_vm.onBack}})}
var staticRenderFns = []

export { render, staticRenderFns }